import { LegalDocument, LegalLink, LegalP, LegalSection, LegalUl } from "../../components/LegalDocument"

export default function Terms() {
    return (
        <LegalDocument title="Пользовательское соглашение">
            <LegalSection title="1. Общие положения">
                <LegalP>
                    1.1. Настоящее Соглашение является публичной офертой в соответствии со статьёй 437 Гражданского
                    кодекса Российской Федерации.
                </LegalP>
                <LegalP>
                    1.2. Используя Сайт или Приложение, Пользователь подтверждает, что ознакомился и полностью согласен
                    с условиями настоящего Соглашения и{" "}
                    <LegalLink to="/privacy">Политикой конфиденциальности</LegalLink>.
                </LegalP>
                <LegalP>
                    1.3. Если Пользователь не согласен с какими-либо условиями Соглашения, он обязан немедленно
                    прекратить использование Сайта и Приложения.
                </LegalP>
                <LegalP>
                    1.4. ООО «Империя игр» оставляет за собой право вносить изменения в Соглашение без предварительного
                    уведомления. Новая редакция вступает в силу с момента её публикации на Сайте.
                </LegalP>
            </LegalSection>

            <LegalSection title="2. Термины и определения">
                <LegalUl
                    items={[
                        <>
                            <strong className="text-white/80">Оператор</strong> — ООО «Империя игр», ИНН/КПП
                            7452030395/745301001, ОГРН 1027403888126, адрес: 454091, Челябинская область, г. Челябинск,
                            Свердловский пр-кт, д. 51а.
                        </>,
                        <>
                            <strong className="text-white/80">Пользователь</strong> — любое физическое лицо,
                            использующее Сайт и/или Приложение.
                        </>,
                        <>
                            <strong className="text-white/80">Аккаунт (Личный кабинет)</strong> — учётная запись
                            Пользователя, создаваемая при регистрации и предоставляющая доступ к функционалу бонусной
                            программы и истории покупок.
                        </>,
                        <>
                            <strong className="text-white/80">Билеты</strong> — электронные билеты, приобретаемые
                            Пользователем через Сайт или Приложение.
                        </>,
                        <>
                            <strong className="text-white/80">Бонусная программа</strong> — программа лояльности,
                            предусматривающая начисление и использование бонусных баллов при покупке билетов.
                        </>,
                    ]}
                />
            </LegalSection>

            <LegalSection title="3. Предмет Соглашения">
                <LegalP>3.1. Оператор предоставляет Пользователю возможность:</LegalP>
                <LegalUl
                    items={[
                        "регистрироваться и авторизовываться на Сайте и/или в Приложении;",
                        "приобретать билеты на киносеансы в онлайн-режиме;",
                        "участвовать в бонусной программе;",
                        "пользоваться Личным кабинетом и историей покупок;",
                        "использовать иные функциональные возможности Сервиса.",
                    ]}
                />
                <LegalP>
                    3.2. Оператор оказывает услуги информационно-технологического характера, обеспечивая взаимодействие
                    между Пользователем и системой продажи билетов.
                </LegalP>
            </LegalSection>

            <LegalSection title="4. Регистрация и Аккаунт">
                <LegalP>4.1. Регистрация Пользователя на Сайте или в Приложении осуществляется Пользователем.</LegalP>
                <LegalP>
                    4.2. Создание Аккаунта одновременно означает вступление Пользователя в бонусную программу. Отказ от
                    участия в бонусной программе невозможен отдельно, без удаления Аккаунта.
                </LegalP>
                <LegalP>
                    4.3. Для удаления Аккаунта и прекращения участия в бонусной программе Пользователь может направить
                    запрос через Telegram, указанный в разделе «Контакты».
                </LegalP>
                <LegalP>4.4. Пользователь обязуется предоставлять достоверные и актуальные данные.</LegalP>
                <LegalP>
                    4.5. Пользователь несёт ответственность за сохранность своих учётных данных и не вправе передавать
                    их третьим лицам.
                </LegalP>
                <LegalP>
                    4.6. В случае несанкционированного доступа Пользователь обязан немедленно уведомить Оператора.
                </LegalP>
            </LegalSection>

            <LegalSection title="5. Покупка билетов">
                <LegalP>5.1. Приобретение билетов осуществляется посредством интерфейса Сайта или Приложения.</LegalP>
                <LegalP>5.2. Оплата билетов производится с использованием доступных платёжных систем.</LegalP>
                <LegalP>
                    5.3. После успешной оплаты электронный билет направляется Пользователю в электронном виде (в Личном
                    кабинете или иным способом).
                </LegalP>
                <LegalP>
                    5.4. Кассовый чек формируется и направляется Пользователю оператором фискальных данных — ООО «Первый
                    ОФД», в соответствии с требованиями Федерального закона № 54-ФЗ.
                </LegalP>
                <LegalP>
                    5.5. Порядок покупки, оплаты и возврата билетов, включая срок отмены до начала сеанса, подробно
                    изложен в{" "}
                    <LegalLink to="/purchase-terms">Условиях покупки и возврата</LegalLink>. Отменить приобретённый
                    билет можно до начала сеанса через Приложение или Личный кабинет на Сайте.
                </LegalP>
            </LegalSection>

            <LegalSection title="6. Бонусная программа">
                <LegalP>
                    6.1. Участие в бонусной программе является обязательным элементом регистрации и осуществляется
                    автоматически.
                </LegalP>
                <LegalP>
                    6.2. Бонусы начисляются в размере от 5% до 10% от суммы покупок, в зависимости от конкретного
                    кинотеатра. Начисление и использование бонусов регулируется действующими правилами, опубликованными
                    на Сайте.
                </LegalP>
                <LegalP>
                    6.3. Пользователь вправе прекратить участие в бонусной программе только путём удаления своего
                    Аккаунта.
                </LegalP>
                <LegalP>
                    6.4. При оплате билетов бонусами минимальная стоимость одного билета составляет 1 (один) рубль.
                </LegalP>
            </LegalSection>

            <LegalSection title="7. Обработка персональных данных">
                <LegalP>
                    7.1. Оператор осуществляет обработку персональных данных Пользователя в соответствии с
                    Федеральным законом № 152-ФЗ «О персональных данных»,{" "}
                    <LegalLink to="/privacy">Политикой конфиденциальности</LegalLink> и{" "}
                    <LegalLink to="/personal-data">Положением об обработке персональных данных</LegalLink>, размещёнными
                    на Сайте.
                </LegalP>
                <LegalP>
                    7.2. Согласие на обработку персональных данных оформляется отдельно от настоящего Соглашения в
                    соответствии с требованиями ст. 9 Закона № 152-ФЗ. Текст согласия и порядок его отзыва приведены в{" "}
                    <LegalLink to="/personal-data">Положении об обработке персональных данных</LegalLink>. Настоящее
                    Соглашение не заменяет и не включает в себя такое согласие.
                </LegalP>
            </LegalSection>

            <LegalSection title="8. Права и обязанности сторон">
                <LegalP>
                    <strong className="text-white/80">Пользователь обязуется:</strong>
                </LegalP>
                <LegalUl
                    items={[
                        "использовать Сайт и Приложение исключительно в законных целях;",
                        "не предпринимать действий, направленных на нарушение работы сервисов или получение несанкционированного доступа к данным других пользователей;",
                        "соблюдать настоящее Соглашение и Политику конфиденциальности.",
                    ]}
                />
                <LegalP>
                    <strong className="text-white/80">Оператор обязуется:</strong>
                </LegalP>
                <LegalUl
                    items={[
                        "обеспечивать стабильную работу сервисов в пределах технических возможностей;",
                        "защищать персональные данные Пользователей в соответствии с законодательством;",
                        "своевременно публиковать изменения условий Соглашения.",
                    ]}
                />
            </LegalSection>

            <LegalSection title="9. Ограничение ответственности">
                <LegalP>9.1. Оператор не несёт ответственности за:</LegalP>
                <LegalUl
                    items={[
                        "временные перебои или прекращение работы Сайта и Приложения;",
                        "достоверность информации, предоставляемой Пользователем;",
                        "убытки, возникшие вследствие несанкционированного использования Аккаунта;",
                        "корректность или задержку отправки электронных чеков оператором фискальных данных (ООО «Первый ОФД»).",
                    ]}
                />
                <LegalP>
                    9.2. Оператор не гарантирует бесперебойную работу внешних сервисов (платёжных систем, операторов
                    связи и т.д.).
                </LegalP>
                <LegalP>
                    9.3. Вся информация на Сайте и в Приложении предоставляется «как есть» без каких-либо гарантий.
                </LegalP>
            </LegalSection>

            <LegalSection title="10. Интеллектуальная собственность">
                <LegalP>
                    10.1. Все элементы Сайта и Приложения (дизайн, тексты, графика, программный код и т.п.) принадлежат
                    ООО «Империя игр».
                </LegalP>
                <LegalP>
                    10.2. Все материалы сайта доступны по лицензии Creative Commons Attribution 4.0 International (CC BY
                    4.0).
                </LegalP>
                <LegalP>10.3. При использовании материалов Сайта ссылка на источник обязательна.</LegalP>
            </LegalSection>

            <LegalSection title="11. Изменение и прекращение доступа">
                <LegalP>
                    11.1. Оператор вправе приостанавливать или прекращать доступ Пользователя к Сайту и Приложению в
                    случае нарушения условий настоящего Соглашения.
                </LegalP>
                <LegalP>
                    11.2. Оператор может изменять или удалять функционал сервисов без предварительного уведомления
                    Пользователя.
                </LegalP>
            </LegalSection>

            <LegalSection title="12. Применимое право и разрешение споров">
                <LegalP>12.1. Настоящее Соглашение регулируется законодательством Российской Федерации.</LegalP>
                <LegalP>
                    12.2. Все споры, вытекающие из настоящего Соглашения, подлежат рассмотрению в суде по месту
                    нахождения Оператора — г. Челябинск.
                </LegalP>
            </LegalSection>

            <LegalSection title="13. Контактная информация">
                <LegalP>
                    <strong className="text-white/80">Оператор:</strong>
                    <br />
                    ООО «Империя игр»
                    <br />
                    ИНН/КПП 7452030395/745301001
                    <br />
                    ОГРН 1027403888126 от 22 декабря 2002 г.
                    <br />
                    Адрес: 454091, Челябинская область, г. Челябинск, Свердловский пр-кт, д. 51а
                    <br />
                    Сайт: <LegalLink href="https://comfortkino.ru">comfortkino.ru</LegalLink>
                    <br />
                    Telegram: <LegalLink href="https://t.me/comfortkinohelp_bot">t.me/comfortkinohelp_bot</LegalLink>
                </LegalP>
            </LegalSection>

            <LegalSection title="14. Заключительные положения">
                <LegalP>
                    14.1. Настоящее Соглашение вступает в силу с момента начала использования Сайта или Приложения.
                </LegalP>
                <LegalP>14.2. Версия Соглашения, размещённая на Сайте, является актуальной.</LegalP>
                <LegalP>
                    14.3. Все предыдущие версии Соглашения утрачивают силу с момента публикации новой редакции.
                </LegalP>
            </LegalSection>
        </LegalDocument>
    )
}
